import { FlexColumn, IconButton } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import intentTrackingService from "app/pages/sales-intelligence/services/tracking/intent/trackingService";
import { showIntentUpsellTopicHook } from "app/pages/sales-intelligence/sub-modules/intent/internalHooks/hooks";
import { AssetsService } from "app/services/AssetsService";

import {
    StyledSignalsPromoBannerButton,
    StyledSignalsPromoBannerContent,
    StyledSignalsPromoBannerImage,
    StyledSignalsPromoBannerSubtitle,
    StyledSignalsPromoBannerTitle,
    StyledSignalsPromoBannerWrapper,
} from "./styles";

const SignalsIntentDataBanner = () => (
    <StyledSignalsPromoBannerWrapper>
        <StyledSignalsPromoBannerImage src={AssetsService.assetUrl("/images/intent/hot_locked.svg")} />
        <StyledSignalsPromoBannerContent>
            <FlexColumn>
                <StyledSignalsPromoBannerTitle data-automation="signal-intent-banner-title">
                    {translate("si.signals.banner.intent-upsell.title")}
                </StyledSignalsPromoBannerTitle>
                <StyledSignalsPromoBannerSubtitle data-automation="signal-intent-banner-subtitle">
                    {translate("si.signals.banner.intent-upsell.subtitle")}
                </StyledSignalsPromoBannerSubtitle>
            </FlexColumn>

            <StyledSignalsPromoBannerButton data-automation="signal-intent-banner-button">
                <IconButton
                    type={"trial"}
                    onClick={() => {
                        void intentTrackingService.trackIntentHook("intent hook", "open popup");
                        showIntentUpsellTopicHook();
                    }}
                    iconName={"sparkles"}
                >
                    {translate("si.common.upgrade")}
                </IconButton>
            </StyledSignalsPromoBannerButton>
        </StyledSignalsPromoBannerContent>
    </StyledSignalsPromoBannerWrapper>
);

export default SignalsIntentDataBanner;
